/* eslint-disable @typescript-eslint/naming-convention */
// Color palette from https://www.figma.com/file/rLsSTygVap7zagoErmncwm/Styles
const colors = {
    forest: {
        "50": "#f8fbfc",
        "100": "#effafb",
        "200": "#d3f1f3",
        "300": "#b3d9db",
        "400": "#75b7bb",
        "500": "#488589",
        "600": "#1d656a",
        "700": "#03484d",
        "800": "#043d41",
        "900": "#002528",
    },
    teal: {
        "50": "#f5fcff",
        "100": "#ebfcff",
        "200": "#cef7fd",
        "300": "#a5e0f9",
        "400": "#6ac1e7",
        "500": "#339ac6",
        "600": "#0e6b93",
        "700": "#0b4f6d",
        "800": "#063448",
        "900": "#021822",
    },
    space: {
        "50": "#f5f8ff",
        "100": "#ebf0ff",
        "200": "#c9d8fe",
        "300": "#acbeeb",
        "400": "#8ea3d9",
        "500": "#6c84c5",
        "600": "#425c9d",
        "700": "#2d447d",
        "800": "#212f51",
        "900": "#0c1528",
    },
    warning: {
        "50": "#fffcf5",
        "100": "#fef9ec",
        "200": "#feeec1",
        "300": "#feda76",
        "400": "#f5c24d",
        "500": "#e49a39",
        "600": "#ce630a",
        "700": "#b54708",
        "800": "#782d0b",
        "900": "#411806",
    },
    danger: {
        "50": "#fffbfa",
        "100": "#ffeceb",
        "200": "#ffe2e0",
        "300": "#f9c8c4",
        "400": "#f69993",
        "500": "#d25046",
        "600": "#a8261f",
        "700": "#7c140c",
        "800": "#6b1109",
        "900": "#411008",
    },
    gray: {
        "50": "#fbfcfd",
        "100": "#eff2f5",
        "200": "#e8edf2",
        "300": "#dbe1e8",
        "400": "#bbc5d0",
        "500": "#9aa6b2",
        "600": "#687786",
        "700": "#4e5b6b",
        "800": "#374352",
        "900": "#252d36",
    },
    peridot: {
        "50": "#fefff5",
        "100": "#f8fbe9",
        "200": "#dee3bf",
        "300": "#cdd79b",
        "400": "#bfc88e",
        "500": "#a4b05d",
        "600": "#869245",
        "700": "#5c651e",
        "800": "#475013",
        "900": "#262b09",
    },
    lightspeed: {
        "50": "#fdfff5",
        "100": "#f9ffe5",
        "200": "#ecf9bd",
        "300": "#e1f49a",
        "400": "#caf239",
        "500": "#adce37",
        "600": "#8da929",
        "700": "#657c0f",
        "800": "#415300",
        "900": "#2b3700",
    },
    avocado: {
        "50": "#f7fdf8",
        "100": "#effaf2",
        "200": "#c0eccb",
        "300": "#99dbab",
        "400": "#76b586",
        "500": "#669d74",
        "600": "#3b864d",
        "700": "#266334",
        "800": "#0e491c",
        "900": "#073012",
    },
    grass: {
        "50": "#f5fffa",
        "100": "#ecfef5",
        "200": "#b8f2d4",
        "300": "#a0e8c2",
        "400": "#79d5a6",
        "500": "#4fc26a",
        "600": "#258e40",
        "700": "#006a34",
        "800": "#004822",
        "900": "#002c16",
    },
    sky: {
        "50": "#f8fbfc",
        "100": "#ecf3f9",
        "200": "#bcd4e8",
        "300": "#9cc1df",
        "400": "#70a3cc",
        "500": "#5581a5",
        "600": "#386c96",
        "700": "#2a567a",
        "800": "#163d5a",
        "900": "#011c32",
    },
    cyan: {
        "50": "#f5feff",
        "100": "#e5fcff",
        "200": "#aaf1fc",
        "300": "#8cdbe8",
        "400": "#3dbfd9",
        "500": "#1198b7",
        "600": "#187999",
        "700": "#1b5c78",
        "800": "#0f4258",
        "900": "#072737",
    },
    ocean: {
        "50": "#f5f8ff",
        "100": "#ebeffa",
        "200": "#b4c7f9",
        "300": "#90aefc",
        "400": "#658df4",
        "500": "#4b6ec8",
        "600": "#2d52b1",
        "700": "#24418c",
        "800": "#11275f",
        "900": "#071538",
    },
    plum: {
        "50": "#f8f5ff",
        "100": "#eee9fb",
        "200": "#d9cbfb",
        "300": "#bfa7f7",
        "400": "#9774ef",
        "500": "#7958cd",
        "600": "#623cc6",
        "700": "#3e1c95",
        "800": "#301a69",
        "900": "#14053a",
    },
    electric: {
        "50": "#f9f4ff",
        "100": "#f1e7fc",
        "200": "#e5d3f9",
        "300": "#cfb5eb",
        "400": "#bd84fa",
        "500": "#ac61ff",
        "600": "#8743d2",
        "700": "#51178d",
        "800": "#310e59",
        "900": "#1a0730",
    },
};
const themeColors = {
    ...colors,
    forest: {
        ...colors.forest,
        dark: colors.forest["800"],
        hover: colors.forest["700"],
        base: colors.forest["600"],
        border: colors.forest["400"],
        background: colors.forest["100"],
    },
    teal: {
        ...colors.teal,
        base: colors.teal["600"],
        border: colors.teal["400"],
        background: colors.teal["100"],
    },
    space: {
        ...colors.space,
        base: colors.space["600"],
        border: colors.space["400"],
        background: colors.space["100"],
    },
    success: {
        base: colors.grass["600"],
        border: colors.grass["400"],
        background: colors.grass["100"],
    },
    warning: {
        ...colors.warning,
        base: colors.warning["600"],
        border: colors.warning["400"],
        background: colors.warning["100"],
    },
    danger: {
        ...colors.danger,
        dark: colors.danger["800"],
        hover: colors.danger["700"],
        base: colors.danger["600"],
        border: colors.danger["400"],
        background: colors.danger["100"],
    },
    gray: {
        ...colors.gray,
        base: colors.gray["600"],
        border: colors.gray["400"],
        background: colors.gray["100"],
    },
    peridot: {
        ...colors.peridot,
        base: colors.peridot["600"],
        border: colors.peridot["400"],
        background: colors.peridot["100"],
    },
    lightspeed: {
        ...colors.lightspeed,
        base: colors.lightspeed["600"],
        border: colors.lightspeed["400"],
        background: colors.lightspeed["100"],
    },
    avocado: {
        ...colors.avocado,
        base: colors.avocado["600"],
        border: colors.avocado["400"],
        background: colors.avocado["100"],
    },
    grass: {
        ...colors.grass,
        base: colors.grass["600"],
        border: colors.grass["400"],
        background: colors.grass["100"],
    },
    sky: {
        ...colors.sky,
        base: colors.sky["600"],
        border: colors.sky["400"],
        background: colors.sky["100"],
    },
    cyan: {
        ...colors.cyan,
        base: colors.cyan["600"],
        border: colors.cyan["400"],
        background: colors.cyan["100"],
    },
    ocean: {
        ...colors.ocean,
        base: colors.ocean["600"],
        border: colors.ocean["400"],
        background: colors.ocean["100"],
    },
    plum: {
        ...colors.plum,
        base: colors.plum["600"],
        border: colors.plum["400"],
        background: colors.plum["100"],
    },
    electric: {
        ...colors.electric,
        base: colors.electric["600"],
        border: colors.electric["400"],
        background: colors.electric["100"],
    },
    text: {
        primary: colors.gray["900"],
        secondary: colors.gray["600"],
        tertiary: colors.gray["500"],
        danger: colors.danger["600"],
    },
    base: {
        border: colors.gray["300"],
        divider: colors.gray["200"],
        background: colors.gray["100"],
        lightBackground: colors.gray["50"],
    },
    primary: {
        pressed: colors.forest["800"],
        hover: colors.forest["700"],
        base: colors.forest["600"],
        border: colors.forest["300"],
        background: colors.forest["100"],
    },
    upsell: {
        dark: colors.space["800"],
        hover: colors.space["700"],
        base: colors.space["600"],
        border: colors.space["400"],
        background: colors.space["50"],
    },
    link: {
        pressed: colors.teal["800"],
        hover: colors.teal["700"],
        default: colors.teal["600"],
    },
};
export default themeColors;
